import React, { useState, useEffect } from "react";
import api from "../utils/api";

export default function TestConnection() {
  const [research, setResearch] = useState([]);
  const [requests, setRequests] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testAPIs = async () => {
      try {
        setLoading(true);
        
        // Get user from localStorage
        const userData = localStorage.getItem("user");
        if (userData) {
          setUser(JSON.parse(userData));
        }

        // Test research API (public)
        const researchRes = await api.get("/research");
        setResearch(researchRes.data.research || []);

        // Test request API (requires auth)
        try {
          const requestsRes = await api.get("/request");
          setRequests(requestsRes.data.requests || []);
        } catch (reqError) {
          console.log("Request API error (expected if not logged in):", reqError.message);
        }

      } catch (error) {
        console.error("API test error:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    testAPIs();
  }, []);

  if (loading) {
    return <div className="p-8 text-center">Testing APIs...</div>;
  }

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">API Connection Test</h1>
      
      {error && (
        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          Error: {error}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-100 p-4 rounded">
          <h2 className="text-lg font-semibold mb-3">User Data</h2>
          <pre className="text-sm overflow-auto">
            {user ? JSON.stringify(user, null, 2) : "No user data"}
          </pre>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="text-lg font-semibold mb-3">Research Data ({research.length})</h2>
          <div className="space-y-2">
            {research.map((item, index) => (
              <div key={index} className="text-sm border-b pb-2">
                <strong>{item.title}</strong><br/>
                Authors: {item.authors?.join(", ")}<br/>
                Public: {item.isPublic ? "Yes" : "No"}<br/>
                Status: {item.status}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="text-lg font-semibold mb-3">Requests Data ({requests.length})</h2>
          <div className="space-y-2">
            {requests.map((item, index) => (
              <div key={index} className="text-sm border-b pb-2">
                <strong>{item.researchId?.title || "Unknown"}</strong><br/>
                Status: {item.status}<br/>
                Reason: {item.reason}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="text-lg font-semibold mb-3">API Status</h2>
          <div className="space-y-2 text-sm">
            <div>✅ Research API: Working</div>
            <div>✅ Request API: {requests.length >= 0 ? "Working" : "Error"}</div>
            <div>✅ User Data: {user ? "Loaded" : "Not loaded"}</div>
            <div>✅ Token: {localStorage.getItem("token") ? "Present" : "Missing"}</div>
          </div>
        </div>
      </div>
    </div>
  );
} 